export const BINARIO = [
  {
    value: true,
    label: 'Sí',
  },
  {
    value: false,
    label: 'No',
  },
];
